export const LocalStorageKeys = {
  selectedLocationId: "selectedLocationId",
  isUsingSharedSettings: "isUsingSharedSettings",
}
